import React from "react";
import { AgencyProvider, useAgency } from "./AgencyContext";

const TABS = [
  { id: "dashboard", label: "Dashboard", hash: "/agency" },
  { id: "clients", label: "Clients", hash: "/agency/clients" },
  { id: "members", label: "Team", hash: "/agency/members" },
  { id: "workflows", label: "Workflows", hash: "/agency/workflows" },
  { id: "invite", label: "Invite", hash: "/agency/invite" },
  { id: "reports", label: "Reports", hash: "/agency/reports" },
  { id: "settings", label: "Settings", hash: "/agency/settings" },
];

function AgencyNav() {
  const { agency } = useAgency();
  const agencyGlobal = typeof window !== "undefined" ? window.__AGENCY__ : null;
  const brandName = agencyGlobal?.brandName || agency?.brand_name || "BrandHives";
  const logoUrl = agencyGlobal?.logoUrl || agency?.logo_url || "";
  const primaryColor = agencyGlobal?.primaryColor || agency?.primary_color || "#0077B5";

  const currentHash = (typeof window !== "undefined" ? window.location.hash : "").replace("#", "");

  return (
    <nav style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 24px", borderBottom: "0.5px solid rgba(0,0,0,0.1)", background: "#fff" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        {logoUrl && <img src={logoUrl} alt="" width="32" height="32" style={{ borderRadius: 8, objectFit: "cover" }} />}
        <span style={{ fontSize: 16, fontWeight: 600, color: "#1a1a1a" }}>{brandName}</span>
        <span style={{ fontSize: 11, color: "#888", background: "#f3f2ef", padding: "2px 8px", borderRadius: 12 }}>Agency</span>
      </div>
      <div style={{ display: "flex", gap: 4 }}>
        {TABS.map(t => {
          const active = currentHash === t.hash || (t.id === "dashboard" && currentHash === "/agency");
          return (
            <a
              key={t.id}
              href={`#${t.hash}`}
              style={{
                padding: "6px 14px", fontSize: 13, borderRadius: 6, textDecoration: "none",
                background: active ? primaryColor : "transparent",
                color: active ? "#fff" : "#666",
                fontWeight: active ? 600 : 400,
              }}>
              {t.label}
            </a>
          );
        })}
      </div>
    </nav>
  );
}

export default function AgencyLayout({ children }) {
  return (
    <AgencyProvider>
      <div style={{ minHeight: "100vh", background: "#f3f2ef", fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif" }}>
        <AgencyNav />
        <div style={{ maxWidth: 1000, margin: "0 auto", padding: "24px 16px 48px" }}>
          {children}
        </div>
      </div>
    </AgencyProvider>
  );
}
